export default __webpack_public_path__ + "static/media/uf.bfa5d17c.png";